/** Display text of one form-field validation issue: a plain string, a lazy thunk, or a `{ message }` object. */
export const fieldErrorMessage = (validationIssue: unknown): string => {
  if (typeof validationIssue === 'string') return validationIssue
  if (typeof validationIssue === 'function') {
    return String(Reflect.apply(validationIssue, undefined, []))
  }
  if (
    validationIssue !== null &&
    typeof validationIssue === 'object' &&
    'message' in validationIssue
  ) {
    return String(validationIssue.message)
  }
  return String(validationIssue)
}
